import { AuthenticationResult } from '@azure/msal-common/dist/response/AuthenticationResult';

import { LocalStorageProperties } from '../../enums/local-storage-properties.enum';
import localStorageService from '../../services/local-storage/local-storage.service';

export const updateLocalStorageInformation = (
  result?: AuthenticationResult
): void => {
  if (result) {
    localStorageService.set(
      LocalStorageProperties.AUTH_TOKEN,
      result.accessToken
    );
    localStorageService.set(LocalStorageProperties.ID_TOKEN, result.idToken);
    localStorageService.set(
      LocalStorageProperties.TOKEN_TYPE,
      result.tokenType
    );
    localStorageService.set(
      LocalStorageProperties.ACCOUNT_INFO,
      result.account
    );
  } else {
    localStorageService.remove(LocalStorageProperties.AUTH_TOKEN);
    localStorageService.remove(LocalStorageProperties.TOKEN_TYPE);
    localStorageService.remove(LocalStorageProperties.ID_TOKEN);
    localStorageService.remove(LocalStorageProperties.ACCOUNT_INFO);
  }
};
